const CHANGE_LANGUAGE = 'global/changeLanguage';
const CHANGE_THEME = 'global/changeTheme';
const SELECT_CREATOR_PROFILE_ID = 'global/selectCreatorProfile';

const initialState = {
  language: { locale: 'en', displayName: 'Eng', direction: 'ltr' },
  theme: 'dark',
  selectedCreatorProfile: {
    id: '',
    name: '',
    image: '',
  },
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CHANGE_LANGUAGE:
      return {
        ...state,
        language: payload,
      };
    case CHANGE_THEME:
      return {
        ...state,
        theme: payload,
      };
    case SELECT_CREATOR_PROFILE_ID:
      return {
        ...state,
        selectedCreatorProfile: {
          id: payload?.id || '',
          name: payload?.name || '',
          image: payload?.image || '',
        },
      };
    default:
      return state;
  }
}

// ACTIONS
export const changeLanguage = (language) => async (dispatch) => {
  dispatch({
    type: CHANGE_LANGUAGE,
    payload: language,
  });
};

export const changeTheme = (theme) => async (dispatch) => {
  dispatch({
    type: CHANGE_THEME,
    payload: theme,
  });
};

export const selectCreatorProfile = (profile) => async (dispatch) => {
  dispatch({
    type: SELECT_CREATOR_PROFILE_ID,
    payload: profile,
  });
};
